// add-to-cart-toast.js
// Universal "Add to cart" detector with green success + red error toasts

(function () {
  // --- Toast UI ---
  function ensureWrap() {
    let wrap = document.getElementById('toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'toast-wrap';
      wrap.style.position = 'fixed';
      wrap.style.right = '20px';
      wrap.style.bottom = '20px';
      wrap.style.display = 'flex';
      wrap.style.flexDirection = 'column';
      wrap.style.gap = '10px';
      wrap.style.zIndex = '999999';
      document.body.appendChild(wrap);
    }
    return wrap;
  }

  function showToast(html, type = 'success') {
    const wrap = ensureWrap();
    const el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.style.maxWidth = '92vw';
    el.style.color = '#fff';
    el.style.padding = '12px 16px';
    el.style.borderRadius = '8px';
    el.style.boxShadow = '0 8px 22px rgba(0,0,0,.28)';
    el.style.fontSize = '14px';
    el.style.lineHeight = '1.35';
    el.style.opacity = '0';
    el.style.transition = 'opacity .25s ease';

    // Success = green, Error = red
    if (type === 'success') {
      el.style.background = '#28a745'; // green
    } else {
      el.style.background = '#dc3545'; // red
    }

    el.innerHTML = html;
    wrap.appendChild(el);
    requestAnimationFrame(() => (el.style.opacity = '1'));
    setTimeout(() => {
      el.style.opacity = '0';
      setTimeout(() => el.remove(), 250);
    }, 3000);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  }

  function handleAddToCartResponse(clonedResponse) {
    clonedResponse.clone().json().then(json => {
      const title = json?.title ? esc(json.title) : 'Item';
      showToast(
        `<strong>${title}</strong> added to cart. <a href="/cart" style="margin-left:12px;text-decoration:underline;color:#fff">View cart</a>`,
        'success'
      );
      try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch {}
    }).catch(() => {
      if (clonedResponse.ok) {
        showToast(`Item added to cart. <a href="/cart" style="margin-left:12px;text-decoration:underline;color:#fff">View cart</a>`, 'success');
      } else {
        clonedResponse.text().then(t => {
          const msg = t && t.length < 120 ? t : 'Could not add to cart.';
          showToast(esc(msg), 'error');
        });
      }
    });
  }

  function isAddToCart(url) {
    try {
      const u = typeof url === 'string' ? new URL(url, location.origin) : new URL(url.url ?? url, location.origin);
      return /\/cart\/add\.js(\?|$)/.test(u.pathname + u.search);
    } catch { return false; }
  }

  // --- Patch fetch ---
  if (!window.__toastFetchPatched) {
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      const p = _fetch.apply(this, arguments);
      try {
        const method = (init?.method || (typeof input === 'object' && input?.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAddToCart(input)) {
          p.then(res => handleAddToCartResponse(res)).catch(() => {});
        }
      } catch {}
      return p;
    };
    window.__toastFetchPatched = true;
  }

  // --- Patch XHR ---
  if (!window.__toastXHRPatched) {
    const XHR = window.XMLHttpRequest;
    const open = XHR.prototype.open;
    const send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__toastMethod = (method || 'GET').toUpperCase();
      this.__toastURL = url;
      return open.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      try {
        if (this.__toastMethod === 'POST' && isAddToCart(this.__toastURL)) {
          this.addEventListener('load', () => {
            try {
              const resInit = { status: this.status, statusText: this.statusText, headers: new Headers({ 'content-type': this.getResponseHeader('content-type') || '' }) };
              const blob = new Blob([this.response || this.responseText || ''], { type: resInit.headers.get('content-type') || 'application/json' });
              const res = new Response(blob, resInit);
              handleAddToCartResponse(res);
            } catch {}
          });
        }
      } catch {}
      return send.apply(this, arguments);
    };
    window.__toastXHRPatched = true;
  }

  console.info('[toast] network hooks active');
})();
